<template>
  <div
    id="uploadFile"
    v-loading="loading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- <div v-show="!upLoadImg1.show"  @click="tragerMyUpload1" class='tragerMyUploadBox'> -->
    <div class="uploadBox">
      <div
        v-for="(item, index) in upLoadImgArr"
        class="uploadImgBox"
        :key="index"
      >
        <img :src="getImageUrl(item)" class="uploadImg" alt />
        <div class="deleteBox">
          <span
            @click="
              () => {
                deleteImgItem(index);
              }
            "
            class="textHover"
            >删除</span
          >
        </div>
      </div>
      <div
        v-if="multitude ? multitude : upLoadImgArr.length < 1"
        @click="tragerMyUpload1"
        class="tragerMyUploadBox"
      >
        <i class="el-icon-plus plusIcon"></i>
      </div>
    </div>

    <div>
      <input
        v-show="false"
        class="file"
        ref="update1"
        type="file"
        @change="update1"
      />
    </div>

    <div v-show="updata_qualified" class="upload-my-tips">
      上传照片格式仅限:png,jpg,jpeg
    </div>
    <div v-show="updata_qualified_size" class="upload-my-tips">
      图片需小于2M
    </div>

    <el-dialog :visible.sync="dialogTableVisible">
      <img :src="currentImg" class="" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import SparkMD5 from "spark-md5";
import { baseUrl, getImageUrl } from "@/api/api";
export default {
  props: ["uploadSuccess", "upLoadFail", "multitude", "initData"],
  data() {
    return {
      currentImg: "",
      dialogTableVisible: false,
      upLoadImgArr: [],
      upLoadImg1: {
        src: "",
        show: false,
      },
      updata_qualified: false,
      updata_qualified_size: false,
      url: "",
      loading: false,
    };
  },
  created() {
    this.getImageUrl = getImageUrl;
  },
  mounted() {
    if (this.initData) {
      console.log("this.initData", this.initData);
      console.log(this.initData.split());
      let imgArr = this.initData.split(',');
      let upLoadImgArr = imgArr.map((item) => {
        return this.getImageUrl(item, "o");
      });

      console.log("upLoadImgArr", upLoadImgArr);
      this.upLoadImgArr = upLoadImgArr;
      // this.upLoadImgArr = (JSON.stringify(this.initData).spilt(',')).map((item)=>(this.getImageUrl(item,'o')))
    }
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  methods: {
    showBigImg(src) {
      (this.currentImg = src), (this.dialogTableVisible = true);
    },
    tragerMyUpload1(index) {
      this.$refs.update1.click(index);
    },
    deleteImgItem(index) {
      this.upLoadImgArr.splice(index, 1);
      this.$nextTick(() => {
        this.$emit("uploadSuccess", { url: this.upLoadImgArr.join() });
      });
    },
    update1(e) {
      console.log(e);
      let that = this;
      this.file_e = e;
      //        文件格式校验
      let flag = false;
      let fileType = e.target.files[0].name.split(".")[1].toLowerCase();

      console.log(e.target.files[0]);
      flag = fileType === "jpg" || fileType === "png" || fileType === "jpeg";
      console.log(e.target.files[0].name.split(".")[1].toLowerCase());
      if (!flag) {
        this.updata_qualified = true;
        return;
      } else {
        this.updata_qualified = false;
      }
      //  大小校验

      if (e.target.files[0].size > this.sizeLimit) {
        this.updata_qualified_size = true;
        return;
      } else {
        this.updata_qualified_size = false;
      }
      this.loading = true;
      //开始分段上传文件了

      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);

      reader.onload = function (ev) {
        let spark = new SparkMD5();
        spark.appendBinary(ev.target.result);

        let base64 = ev.target.result;
        let md5 = spark.end();
        let file = e.target.files[0];
        let size = e.target.files[0].size;
        let chunkSize = e.target.files[0].size;
        let chunks = Math.ceil(size / chunkSize);
        let param = new FormData(); //创建form对象

        let url =
          `${baseUrl}/uploadfast/chunkUpload/checkFile?fileMd5=` +
          md5 +
          "&userId=" +
          that.userInfo.userId;

        //          application/x-www-form-urlencoded
        //          multipart/form-data
        //          application/json;charset=UTF-8
        //          application/json
        //          text/xml

        that
          .$axios({
            method: "post",
            url: url,
          })
          .then((data) => {
            console.log(data);
            if (!data.data.data.viewPath) {
              let UPLOADFILE_URL = `${baseUrl}/uploadfast/chunkUpload/upload_do`;

              param.append("file", base64);
              param.append("name", e.target.files[0].name + "");
              param.append("chunk", data.data.data.chunkCurr);
              param.append("chunks", chunks);
              param.append("chunkSize", chunkSize);
              param.append("size", size + "");
              param.append("fileMd5", md5);
              param.append("userId", that.userInfo.userId + "");

              //              console.log('base64', base64)
              //              console.log('name', e.target.files[0].name)
              //              console.log('chunk', data.data.data.chunkCurr)
              //              console.log('chunks', chunks)
              //              console.log('chunkSize', chunkSize)
              //              console.log('size', size)
              //              console.log('fileMd5', md5)
              //              console.log('userId', that.userInfo.userId)

              var xhr = new XMLHttpRequest();
              xhr.open("POST", UPLOADFILE_URL, true);
              xhr.addEventListener("readystatechange", () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                  const res = JSON.parse(xhr.response);
                  console.log(res);
                  if (res.data) {
                    let url = `${baseUrl}/${res.data}`;
                    console.log(url);
                    that.upLoadImg1.src = url;
                    that.upLoadImgArr.push(res.data);
                    that.$nextTick(() => {
                      that.$emit("uploadSuccess", {
                        url: that.upLoadImgArr.join(),
                      });
                    });
                    that.$refs.update1.value = "";
                    that.loading = false;
                    that.upLoadImg1.show = true;
                  } else {
                    console.log(333);
                    console.log(res.msg);
                  }
                }
              });

              console.log("param", param);
              xhr.send(param);
              param = null;
              that.loading = false;
            } else {
              console.log("服务器存在本文件");
              let url = `${baseUrl}/${data.data.data.viewPath}`;
              console.log(url);
              that.upLoadImgArr.push(data.data.data.viewPath);
              that.$nextTick(() => {
                that.$emit("uploadSuccess", { url: that.upLoadImgArr.join() });
              });

              that.upLoadImg1.src = url;
              that.$refs.update1.value = "";
              that.upLoadImg1.show = true;
              that.loading = false;
            }
          });
      };
    },
  },
};
</script>
<style lang='less' scoped>
#uploadFile {
  display: inline-block;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  width: 80%;
  margin: 50px auto;
}
.tragerMyUploadBox {
  display: flex;
  height: 60px;
  width: 60px;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.uploadBox {
  display: flex;
  max-width: 600px;
  flex-direction: row;
}
.plusIcon {
  font-size: 26px;
  color: #999;
}
.uploadImg {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.deleteBox {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #009688;
  height: 15px;
  margin-top: -5px;
}
.uploadImgBox {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/components/UploadFile/UploadFile.vue